export default __webpack_public_path__ + "static/media/text_editor_icon.451ab98c.svg";